import { Box, styled, Typography, Paper } from "@mui/material";

// Layout background with padding
export const CustomLayout = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

// Elegant paper container
export const CustomPaper = styled(Paper)(() => ({
  width: "100%",
  padding: "20px",
  boxSizing: "border-box",
  backgroundColor: "#ffffff",
  marginBottom: "16px",
  borderRadius: "12px",
  boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.05)",
  transition: "box-shadow 0.3s ease-in-out",
  "&:hover": {
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
  },
}));

// Professional title styling
export const CustomTypographyForTitle = styled(Typography)(() => ({
  fontSize: "22px",
  fontWeight: 600,
  lineHeight: 1.4,
  color: "#16325B",
  marginBottom: "12px",
  textTransform: "capitalize",
}));

// Color constants
export const PrimaryColor = "#16325B";
export const DeleteColor = "#A04747";
export const TextColor = "#333333";
